import {connect} from 'react-redux';

import AnmeldungBestaetigenForm from './AnmeldungBestaetigenForm';
import {
  getIsTransmitting,
  getTransmissionResult,
  getTransmissionStatus,
  sendAnmeldungBestaetigenRequest,
} from '../../main';

function mapStateToProps(state) {
  let transmissionResult = getTransmissionResult(state.main);
  let transmissionStatus = getTransmissionStatus(state.main);

  let result = {
    transmitting: getIsTransmitting(state.main),
    transmissionStatus: transmissionStatus,
    error: transmissionStatus === 'error' ? true : false,
    errorText: ((typeof transmissionResult === 'string' && transmissionResult) || (transmissionResult && transmissionResult.response && transmissionResult.response.statusText)),
    statusCode: transmissionResult && transmissionResult.response && transmissionResult.response.status,
  };
  return result;
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    onComponentWillMount: () => {
      dispatch(sendAnmeldungBestaetigenRequest(ownProps.uuid))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AnmeldungBestaetigenForm)



// WEBPACK FOOTER //
// ./src/components/anmeldung-bestaetigen/AnmeldungBestaetigenComponent.js